import * as Yup from 'yup';

import { Permission, Role } from '../../../../shared/enum';
import { getRoleHelpText, getRoleLabel } from '../../utils';

export const userFormSchema = Yup.object().shape({
  role: Yup.string().required().label('Role'),
  name: Yup.string().required().label('Name'),
  email: Yup.string().email().required().label('Email address'),
  mobileNumber: Yup.string()
    .required()
    .matches(/^\+[1-9]\d{3,14}$/, 'Mobile number is not in the correct format')
    .label('Mobile number'),
  folderIds: Yup.array().label('Folder access'),
});

export const getRoleRadioGroupItems = (permissions: Permission[]) => [
  {
    helpText: getRoleHelpText(Role.FullAdmin),
    label: getRoleLabel(Role.FullAdmin),
    value: Role.FullAdmin,
    disabled: !permissions.includes(Permission.CreateFullAdmin),
  },
  {
    helpText: getRoleHelpText(Role.RestrictedAdmin),
    label: getRoleLabel(Role.RestrictedAdmin),
    value: Role.RestrictedAdmin,
  },
  {
    helpText: getRoleHelpText(Role.User),
    label: getRoleLabel(Role.User),
    value: Role.User,
  },
  {
    helpText: getRoleHelpText(Role.DECC),
    label: getRoleLabel(Role.DECC),
    value: Role.DECC,
  },
  {
    helpText: getRoleHelpText(Role.RSP),
    label: getRoleLabel(Role.RSP),
    value: Role.RSP,
  },
  {
    helpText: getRoleHelpText(Role.IndependentAuditor),
    label: getRoleLabel(Role.IndependentAuditor),
    value: Role.IndependentAuditor,
  },
];
